import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { CopiedTooltip, CopyWrapper } from './styles';
import copy from 'copy-to-clipboard';

type Props = {
  children: ReactNode;
  value: string;
  disabled?: boolean;
}

export const CopyField: React.FC<Props> = ({ children, value, disabled }) => {
  const [copied, setCopied] = useState(false);
  const [ tooltipPos, setTooltipPos ] = useState<'left' | 'right'>('right')

  const wrapper = useRef<HTMLDivElement>(null);

  const setPosition = () => {
    if (!wrapper.current) return;

    const wrapperRect = wrapper.current.getBoundingClientRect();

    const wrapperWidth = wrapperRect.width;
    const wrapperLeftPos = wrapperRect.left;
    const wrapperRightPos = window.innerWidth - (wrapperWidth + wrapperLeftPos);

    if (wrapperLeftPos <= wrapperRightPos) {
      return setTooltipPos('right');
    } else {
      return setTooltipPos('left');
    }
  }

  useEffect(() => {
    setPosition();
  }, [wrapper])

  const onClick = () => {
    copy(value)
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000)
  }

  return (
  <CopyWrapper 
    $disabled={disabled ? 'true' : 'false'} 
    onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined} 
    onTouchStart={onClick}
    ref={wrapper}
  >
      {copied && <CopiedTooltip $position={tooltipPos}>Скопировано</CopiedTooltip>}
      {children}
  </CopyWrapper>
  )
}